import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputBase,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import people from "../../../../assets/svg/ellipse.svg";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { addCampaignReferral, getCampaigns } from "../../../../helper/campaign";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUsers,
  getCustomersByRoutePartnerId,
} from "../../../../helper/functions";
import { toast } from "react-toastify";
import { setCampaigns } from "../../../../store/campaign";
import { addedByConversion } from "../../../Shipping/ShippingService/shippingService.helper";

const initalValues = {
  forAllCustomers: false,
  forAllUsers: false,
  emails: [],
  expiryDate: "",
  isNeverExpire: false,
  referralBonus: 0,
  referralType: "",
  maxReferralAmount: 0,
  publicNote: "",
  internalNote: "",
  referralCampaignType: "",
  friendReferalBonus: 0,
};

const countReferralDetails = (referralType) => {
  switch (referralType) {
    case "1st shipment only":
      return {
        specificOccurence: [1],
        boundedOccurence: [],
      };
    case "next 5 shipment within 12 months":
      return {
        specificOccurence: [],
        boundedOccurence: [
          {
            month: 12,
            numberOfShipment: 5,
          },
        ],
      };
    case "next 10 shipment within 6 months":
      return {
        specificOccurence: [],
        boundedOccurence: [
          {
            month: 6,
            numberOfShipment: 10,
          },
        ],
      };
  }
};

const AddReferalCampaign = ({ setAddFundDrawer }) => {
  const dispatch = useDispatch();
  const [customerMails, setCustomerMails] = useState([]);
  const user = useSelector((state) => state.auth.value);
  console.log(user, "userdfsdf");
  useEffect(() => {
    const getCustomers = async () => {
      const customers = await getCustomersByRoutePartnerId(
        user?.routePartnerId,
      );
      setCustomerMails(customers);
      console.log(customers, "customers1111");
    };
    const getUsers = async () => {
      const users = await getAllUsers();
      console.log(users, "usersacds");
      setCustomerMails(users);
    };
    if (user) {
      if (user?.role === "Route Partner Admin") {
        getCustomers();
      } else {
        getUsers();
      }
    }
  }, [user]);
  const formik = useFormik({
    initialValues: initalValues,
    onSubmit: async (values) => {
      try {
        const isAllUsers = values.forAllCustomers || values.forAllUsers;
        const campaignEmails = isAllUsers
          ? customerMails
              .filter((u) => u.email)
              .map((u) => ({ email: u.email, userId: u.id }))
          : values.emails.map((e) => ({ email: e.email, userId: e.userId }));

        const referralDetails = countReferralDetails(values?.referralType);
        // delete values.referralType;
        const offeredBy =
          user?.role === "Superadmin" ? "POSTPAL" : user?.routePartnerName;
        const response = await addCampaignReferral({
          ...values,
          emails: campaignEmails,
          ...referralDetails,
          campaignType: "referral_campaign",
          addedByUserId: user?.id,
          routePartnerId: user?.routePartnerId || "",
          addedBy: addedByConversion(user?.role),
          offeredBy,
        });

        const campaignsResponse = await getCampaigns();
        dispatch(setCampaigns(campaignsResponse));
        setAddFundDrawer(false);
        toast.success("Referal campaign added successfully");

        // await notifyCustomersForReferralOffer(
        //     values.forAllCustomers || values.forAllUsers,
        //     customerMails,
        //     values.emails,
        //     values,
        //     user
        // );
        toast.success("Referal campaign notification sent successfully");
      } catch (error) {
        console.error("Error adding referral campaign:", error);
        toast.error("Failed to add referral campaign");
      }
    },
  });
  const emailOptions = customerMails.map((option) => ({
    email: option.email,
    userId: option.id,
  }));

  return (
    <Box>
      {user?.role === "Route Partner Admin" && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="For all customers"
            control={
              <Checkbox
                size="small"
                onChange={(event) => {
                  if (event.target.checked) {
                    formik.setFieldValue("emails", []);
                  }
                  formik.setFieldValue("forAllCustomers", event.target.checked);
                }}
              />
            }
          />
        </Box>
      )}
      {user?.role != "Route Partner Admin" && (
        <Box
          sx={{
            paddingX: "20px",
          }}
        >
          <FormControlLabel
            label="For all users"
            control={
              <Checkbox
                size="small"
                onChange={(event) => {
                  if (event.target.checked) {
                    formik.setFieldValue("emails", []);
                  }
                  formik.setFieldValue("forAllUsers", event.target.checked);
                }}
              />
            }
          />
        </Box>
      )}
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Email
        </Typography>
        <FormControl fullWidth>
          <Autocomplete
            multiple
            size="small"
            options={emailOptions}
            getOptionLabel={(option) => option.email}
            value={formik?.values?.emails || []}
            disabled={
              formik?.values?.forAllCustomers || formik?.values?.forAllUsers
            }
            onChange={(event, newValue) => {
              formik.setFieldValue("emails", newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select emails"
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.email}
                  {...getTagProps({ index })}
                  key={index}
                />
              ))
            }
          />
        </FormControl>
      </Box>
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Expiry Date
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(newValue) =>
              formik.setFieldValue(
                "expiryDate",
                dayjs(newValue).format("YYYY-MM-DD"),
              )
            }
            value={dayjs(formik?.values?.expiryDate)}
            disabled={formik?.values?.isNeverExpire}
            renderInput={(params) => <TextField {...params} name="endDate" />}
            sx={{
              width: "100%",
            }}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ paddingX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Referal Campaign Type
        </Typography>
        <FormControl fullWidth>
          <Select
            size="small"
            value={formik.values.referralCampaignType}
            onChange={(e) => {
              formik.setFieldValue("referralCampaignType", e.target.value);
            }}
            sx={{ marginTop: "8px" }}
          >
            {/* <MenuItem value="push_notification">Push Notification</MenuItem> */}
            <MenuItem value="PAP">PAP</MenuItem>
            <MenuItem value="GPR">GPR</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box
        sx={{
          paddingX: "20px",
        }}
      >
        <FormControlLabel
          label="Never Expired"
          control={
            <Checkbox
              size="small"
              onChange={(event) => {
                if (event.target.checked) {
                  formik.setFieldValue("expiryDate", "");
                }
                formik.setFieldValue("isNeverExpire", event.target.checked);
              }}
            />
          }
        />
      </Box>
      <Box
        sx={{
          marginX: "20px",
          paddingTop: "10px",
          padding: "8px",
          paddingY: "12px",
          backgroundColor: "#f7f7f7",
          border: "1px solid #E5E5E8",
          borderRadius: "8px",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "16px",
              marginLeft: "16px",
              fontWeight: 700,
            }}
          >
            Referral Bonus
          </Typography>
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <Box
            sx={{
              marginLeft: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography>You get</Typography>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "20%", marginX: "5px" }}
              value={formik?.values?.referralBonus}
              onChange={(event) =>
                formik.setFieldValue("referralBonus", event.target.value)
              }
              InputProps={{
                startAdornment: <InputAdornment>%</InputAdornment>,
              }}
            />
            <Typography>for the next</Typography>
            <FormControl sx={{ marginX: "5px", minWidth: 120 }}>
              <Select
                defaultValue=""
                size="small"
                value={formik?.values?.referralType}
                onChange={(event) =>
                  formik.setFieldValue("referralType", event.target.value)
                }
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                <MenuItem value={"1st shipment only"}>
                  1st shipment ONLY
                </MenuItem>
                <MenuItem value={"next 5 shipment within 12 months"}>
                  Next 5 shipment within 12 months
                </MenuItem>
                <MenuItem value={"next 10 shipment within 6 months"}>
                  Next 10 shipment within 6 months
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box
            sx={{
              marginLeft: "16px",
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Typography>with a</Typography>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "60px", marginX: "5px" }}
              value={formik?.values?.maxReferralAmount}
              onChange={(event) =>
                formik.setFieldValue("maxReferralAmount", event.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography>
              maximum per shipping, and your friends will get
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "60px", marginX: "5px" }}
              value={formik?.values?.friendReferalBonus}
              onChange={(event) =>
                formik.setFieldValue("friendReferalBonus", event.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "10px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Public Note
        </Typography>
        <TextField
          name="publicNote"
          variant="outlined"
          size="small"
          fullWidth
          onChange={(event) =>
            formik.setFieldValue("publicNote", event.target.value)
          }
          value={formik?.values?.publicNote}
        />
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "20px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Internal Note
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          multiline
          rows={5}
          name="internalNote"
          value={formik?.values?.internalNote}
          onChange={(event) =>
            formik.setFieldValue("internalNote", event.target.value)
          }
        />
      </Box>
      <Box sx={{ marginX: "20px", paddingTop: "10px", paddingBottom: "20px" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          Applied by
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
          <img src={people} alt="people" width={24} height={24} />
          <Typography sx={{ marginLeft: "10px" }}>{user?.name}</Typography>
        </Box>
      </Box>
      {/* Fixed positioned button at bottom right */}
      <Box
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#481AA3",
            color: "#fff",
            border: "none",
            boxShadow: "0px 4px 12px rgba(72, 26, 163, 0.3)",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: 600,
            textTransform: "none",
            minWidth: "200px",
            height: "48px",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#5E17EB",
              boxShadow: "0px 6px 16px rgba(72, 26, 163, 0.4)",
              transform: "translateY(-2px)",
            },
            "&:active": {
              transform: "translateY(0px)",
            },
          }}
          onClick={formik.handleSubmit}
        >
          Generate Referral Campaign
        </Button>
      </Box>
    </Box>
  );
};

export default AddReferalCampaign;
